export enum PageViews {
  Intro = "Intro",
  FindCar = "FindCar",
  Details = "Details",
  Thanks = "Thanks"
}

export enum FindViews {
  Find = "Find",
  Found = "Found",
  NotFound = "NotFound",
  NotMyCar = "NotMyCar"
}

export enum UserStatus {
  New = "New",
  Existing = "Existing"
}

export enum VehicleIdType {
  Registration = "Registration",
  Vin = "Vin"
}

export interface VehicleInfo {
  vin: string;
  registration?: string;
  year: number;
  modelName: string;
  variant: string;
  warrantyEligible: boolean;
}

export interface FormFieldState {
  value: any;
  isValid: boolean;
}

export interface FormData {
  commsPhone: boolean;
  commsEmail: boolean;
  commsSms: boolean;
  commsPost: boolean;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  dob: string;
  postcode: string;
  streetAddress: string;
  suburb: string;
  state: string;
  purchaseDate: string;
  roadsideAssist: boolean;
  optSurvey: boolean;
  optPrivacy: boolean;
  optMotoringClub: boolean;
}

export interface FormPayload {
  userDetails: FormData;
  vehicle: VehicleInfo;
}

export enum NotificationTypes {
  Error = "Error",
  Success = "Success",
  Warning = "Warning"
}

export interface Notification {
  id?: string;
  type: NotificationTypes;
  text: string;
}
